import { createElement, ReactNode } from 'react';

import { ResourceVersionListItem, VersionedResourceType } from '@/types';

import MemoVersionPreview from '../MemoVersionPreview';
import { buildMemoVersionDiff } from '../MemoVersionPreview/memoDiff';

interface ResourceSnapshotPreviewDefinition {
    getChangeCount: (version: ResourceVersionListItem) => number;
    render: (version: ResourceVersionListItem) => ReactNode;
}

const resourceSnapshotPreviewDefinitions: Partial<Record<VersionedResourceType, ResourceSnapshotPreviewDefinition>> = {
    memos: {
        getChangeCount: (version) => buildMemoVersionDiff(version).changes.length,
        render: (version) => createElement(MemoVersionPreview, { key: version.id, version }),
    },
};

export const getSnapshotPreviewChangeCount = (
    resourceType: VersionedResourceType,
    version: ResourceVersionListItem,
): number =>
    resourceSnapshotPreviewDefinitions[resourceType]?.getChangeCount(version) ?? version.changes?.length ?? 0;

export const renderResourceSnapshotPreview = (
    resourceType: VersionedResourceType,
    version: ResourceVersionListItem,
): ReactNode => resourceSnapshotPreviewDefinitions[resourceType]?.render(version);
